import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

import { Waiting } from '../../../common/components/Waiting/Waiting';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Filter, FilterReportData } from '../RegistersView/Filter';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const ReportBillingSummaryView: React.FC = () => {
  const spd = useSpdCore();
  const [waiting, setWaiting] = useState<boolean>(false);
  const [alert, setAlert] = useState<string>('');

  const onSearch = async (filter: FilterReportData) => {
    setAlert('Pobieranie danych, proszę czekać...');
    setWaiting(true);

    const currentDate = new Date().toISOString().split('T')[0];
    try {
      await spd.reportsExcel.reportBillingSummary(
        `kwoty_swiadczen_${currentDate}.xlsx`,
        filter,
      );
      setWaiting(false);
    } catch (response) {
      const err = await responseErrors(response as ResponseError);
      toast.error(err?.[0]);
      setWaiting(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Filter
        onSearch={onSearch}
        headerName={'Kwoty świadczeń wg firm wg daty końca badania'}
        roles={[]}
        withUser={false}
        withDate={true}
        withEndStartDate={true}
        withHealthcareFacility={true}
        emptyOnStart={true}
        withCompany={true}
        canClean={true}
        withExamined={true}
      />
      {waiting && (
        <>
          <Alert variant="warning">{alert}</Alert>
          <Waiting />
        </>
      )}
    </>
  );
};
